/** Perfiles oficiales DreamVinyl (escucha vía redes — ver docs/appendix/marketplace_ficha_v2_y_redes_spec.md). */
export const DREAMVINYL_SOCIAL_LABELS = {
  instagram: 'Instagram DreamVinyl',
  tiktok: 'TikTok DreamVinyl',
  youtube: 'YouTube DreamVinyl',
  telegram: 'Telegram DreamVinyl',
  facebook: 'Facebook DreamVinyl',
};

/** Handles para pie de posts en redes (alineado con socialPublish.ts en Edge). */
export const DREAMVINYL_SOCIAL_HANDLES = {
  telegram: '@DreamVinylComunidad',
  instagram: '@dreamvinyloficial',
  facebook: 'dreamvinyloficial',
};

export function dreamvinylOfficialSocialUrl(platform) {
  const key = String(platform || '').trim().toLowerCase();
  const fromEnv = {
    instagram: process.env.REACT_APP_DREAMVINYL_SOCIAL_INSTAGRAM,
    tiktok: process.env.REACT_APP_DREAMVINYL_SOCIAL_TIKTOK,
    youtube: process.env.REACT_APP_DREAMVINYL_SOCIAL_YOUTUBE,
    telegram: process.env.REACT_APP_DREAMVINYL_SOCIAL_TELEGRAM,
  }[key];
  const url = String(fromEnv || '').trim();
  if (url) return url;
  if (key === 'telegram') return 'https://t.me/DreamVinylComunidad';
  return null;
}
